module.exports = __webpack_public_path__ + "img/christiandrosten.d78b4aa4.png";